import { render, staticRenderFns } from "./FaviconManager.vue?vue&type=template&id=21d15148&scoped=true&"
import script from "./FaviconManager.vue?vue&type=script&lang=js&"
export * from "./FaviconManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d15148",
  null
  
)

export default component.exports